import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-maintenance",
  "use": "app-maintenance-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-maintenance\"><defs><style>#app-maintenance .cls-1{fill:#3badf6;}#app-maintenance .cls-2{fill:#fff;}</style></defs><title>资源 38</title><g id=\"app-maintenance_图层_2\" data-name=\"图层 2\"><g id=\"app-maintenance_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M38,10.5H12.48a1.17,1.17,0,0,0-1.17,1.17V38.33a1.17,1.17,0,0,0,1.17,1.17H38a1.17,1.17,0,0,0,1.17-1.17V11.67A1.17,1.17,0,0,0,38,10.5ZM32.6,34l-.14.14a1.38,1.38,0,0,1-1.95,0l-3.8-3.8,0,0a.5.5,0,1,1-.71-.71l.82-.82L25.95,28l-3.19,3.19L22,33.8l-2.66.73-.26-.26,1-1V32H18.83l-1,1-.37-.37.74-2.66,2.66-.73L24,26,20.4,22.4h0l-.53-.33-.72-.93.52-.52.93.72.3.56h0l3.62,3.62L26,24l.73-2.66,2.66-.73.37.37-1,1v1.29H30l1-1,.26.26-.74,2.66L27.95,26l-1.51,1.51.85.85.82-.82a.5.5,0,0,1,.71.71l0,0L32.6,32A1.38,1.38,0,0,1,32.6,34Zm.62-19.73v1.5h-16V11h1.5v3.25h13V11h1.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-maintenance.svg
// module id = Nenf
// module chunks = 264